import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";
import logo from "./assets/logo.png";
import click from "./assets/sounds/click.mp3";
import { useTranslation } from "react-i18next";
import frFlag from "./assets/fr.png";
import enFlag from "./assets/en.png";

export default function Home({ onNext }) {
  const navigate = useNavigate();
  const [mode, setMode] = useState(null); // null | "login" | "signup" | "forgot"
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [unlockCode, setUnlockCode] = useState("");
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");
  const API_URL = process.env.REACT_APP_API_URL;

  const handleLogin = async () => {
    try {
      const res = await fetch(`${API_URL}/api/auth/login`, { //Ici
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, lang: i18n.language }),
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.message || t("errors.loginGeneric"));
      }

      const data = await res.json();
      localStorage.setItem("token", data.token);
      setError("");
      onNext(data.token);
      navigate("/profiles");
    } catch (err) {
      setError(err.message || t("errors.login"));
    }
  };

    const playSound = (sound) => {
    const audio = new Audio(sound);
    audio.play();
    };
  const { t, i18n } = useTranslation();

  const changeLang = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
  };
  const handleSignup = async () => {
    try {
      const res = await fetch(`${API_URL}/api/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, unlockCode, lang: i18n.language }),
      });

      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.message || t("errors.signup"));
      }

      const data = await res.json();
      setInfo(data.message || t("info.signupSuccess"));
      setError("");
    } catch (err) {
      setError(err.message || t("errors.signupGeneric"));
    }
  };

  const handleForgot = async () => {
    try {
      const res = await fetch(`${API_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, lang: i18n.language }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || t("errors.forgot"));

      setInfo(data.message || t("info.forgotSuccess"));
      setError("");
    } catch (err) {
      setError(err.message);
      setInfo("");
    }
  };

  return (
    <div className="home-container">
      <img src={logo} alt="VinOdys’sait" className="logo" />
      <div className="lang-switch">
        <img src={frFlag} alt="FR" onClick={() => changeLang("fr")} />
        <img src={enFlag} alt="EN" onClick={() => changeLang("en")} />
      </div>
      <h2>{t("home.welcome")}</h2>

      {/* --- Menu principal --- */}
      {!mode && (
        <div className="button-group">
          <button className="bg-White-700" onClick={() => {playSound(click);setMode("login")}}>
            
            {t("home.login")}
          </button>
          <button className="bg-Purple-700" onClick={() => {playSound(click);setMode("signup")}}>
            {t("home.signup")}
          </button>
        </div>
      )}

      {/* --- Formulaire login --- */}
      {mode === "login" && (
        <div className="form-container show">
          <input
            type="email"
            placeholder={t("home.email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder={t("home.password")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {error && <p className="error-msg">{error}</p>}
          {info && <p className="info-msg">{info}</p>}

          <div className="button-group">
            <button className="bg-White-700" onClick={() => {playSound(click);handleLogin()}}>
              
              {t("home.login")}
            </button>
            <button
              className="bg-Purple-700"
              onClick={() => {
                playSound(click)
                setError("");
                setInfo("");
                setMode("forgot");
              }}
            >
              {t("home.forgot")}
            </button>
            <button className="back-btn" onClick={() => {playSound(click);setMode(null)}}>
              ←
            </button>
          </div>
        </div>
      )}

      {/* --- Formulaire signup --- */}
      {mode === "signup" && (
        <div className="form-container show">
          <input
            type="email"
            placeholder={t("home.email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder={t("home.password")}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <input
            type="text"
            placeholder={t("home.unlockCode")}
            value={unlockCode}
            onChange={(e) => setUnlockCode(e.target.value)}
          />

          {error && <p className="error-msg">{error}</p>}
          {info && <p className="info-msg">{info}</p>}

          <div className="button-group">
            <button className="bg-Purple-700" onClick={() => {playSound(click);handleSignup()}}>
             {t("home.signup")}
            </button>
            <button className="back-btn" onClick={() => {playSound(click);setMode(null)}}>
              ←
            </button>
          </div>
        </div>
      )}

      {/* --- Formulaire forgot password --- */}
      {mode === "forgot" && (
        <div className="form-container show">
          <input
            type="email"
            placeholder={t("home.yourEmail")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          {error && <p className="error-msg">{error}</p>}
          {info && <p className="info-msg">{info}</p>}

          <div className="button-group">
            <button className="bg-Purple-700" onClick={() => {playSound(click);handleForgot()}}>
              {t("home.sendLink")}
            </button>
            <button className="back-btn" onClick={() => {playSound(click);setMode("login")}}>
              ←
            </button>
          </div>
        </div>
      )}

            <a
        href="https://www.odyssait.com"
        className="bottom-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t("home.link")}
      </a>
    </div>
  );
}


